import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import RewardRedemptionCard from './RewardRedemptionCard';

var RewardsRecommendationListing = function RewardsRecommendationListing(props) {
  var _props$rewardsState4, _selectedValues$rewar, _selectedValues$rewar2, _selectedValues$rewar3;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      recommendedRewards = _useState2[0],
      setRecommendedRewards = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      orderedRewards = _useState4[0],
      setOrderedRewards = _useState4[1];

  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      bonusRewards = props.bonusRewards,
      selectedValues = props.selectedValues,
      setSelectedValues = props.setSelectedValues,
      availableRewards = props.availableRewards,
      _props$rewardBadge = props.rewardBadge,
      rewardBadge = _props$rewardBadge === void 0 ? null : _props$rewardBadge,
      _props$releaseRedempt = props.releaseRedemptionEngineV2,
      releaseRedemptionEngineV2 = _props$releaseRedempt === void 0 ? false : _props$releaseRedempt,
      _props$unavailableRew = props.unavailableRewardCopy,
      unavailableRewardCopy = _props$unavailableRew === void 0 ? null : _props$unavailableRew;
  var Header = model.Header,
      NoBonusCopy = model.NoBonusCopy,
      BonusCopy = model.BonusCopy,
      MaximumRewardsCopy = model.MaximumRewardsCopy,
      LimitRewardsCopy = model.LimitRewardsCopy;
  useEffect(function () {
    var _props$rewardsState, _props$rewardsState$r, _props$rewardsState$r2;

    var recommendedRewardsAux = [];

    if (((_props$rewardsState = props.rewardsState) === null || _props$rewardsState === void 0 ? void 0 : (_props$rewardsState$r = _props$rewardsState.rewardsRedemptionResponse) === null || _props$rewardsState$r === void 0 ? void 0 : (_props$rewardsState$r2 = _props$rewardsState$r.redeemOptions) === null || _props$rewardsState$r2 === void 0 ? void 0 : _props$rewardsState$r2.length) > 0) {
      if (releaseRedemptionEngineV2) {
        var _props$rewardsState2, _props$rewardsState2$, _props$rewardsState2$2, _props$rewardsState2$3;

        recommendedRewardsAux = (_props$rewardsState2 = props.rewardsState) === null || _props$rewardsState2 === void 0 ? void 0 : (_props$rewardsState2$ = _props$rewardsState2.rewardsRedemptionResponse) === null || _props$rewardsState2$ === void 0 ? void 0 : (_props$rewardsState2$2 = _props$rewardsState2$.redeemOptions[0]) === null || _props$rewardsState2$2 === void 0 ? void 0 : (_props$rewardsState2$3 = _props$rewardsState2$2.rewardsApplied) === null || _props$rewardsState2$3 === void 0 ? void 0 : _props$rewardsState2$3.filter(function (reward) {
          return reward.couponCode && reward.couponCode !== '';
        }).map(function (reward) {
          return reward.rewardId;
        });
      } else {
        var _props$rewardsState3, _props$rewardsState3$, _props$rewardsState3$2, _props$rewardsState3$3;

        recommendedRewardsAux = (_props$rewardsState3 = props.rewardsState) === null || _props$rewardsState3 === void 0 ? void 0 : (_props$rewardsState3$ = _props$rewardsState3.rewardsRedemptionResponse) === null || _props$rewardsState3$ === void 0 ? void 0 : (_props$rewardsState3$2 = _props$rewardsState3$.redeemOptions[0]) === null || _props$rewardsState3$2 === void 0 ? void 0 : (_props$rewardsState3$3 = _props$rewardsState3$2.bonusRewardsRedeemed) === null || _props$rewardsState3$3 === void 0 ? void 0 : _props$rewardsState3$3.map(function (reward) {
          return reward.bonusRewardId;
        });
      }

      setRecommendedRewards(recommendedRewardsAux);
    }

    var recommended = [];
    var available = [];
    var unavailable = [];
    bonusRewards === null || bonusRewards === void 0 ? void 0 : bonusRewards.forEach(function (bonusReward) {
      var _recommendedRewardsAu, _bonusReward$fields$E, _bonusReward$fields$E2;

      if ((_recommendedRewardsAu = recommendedRewardsAux) === null || _recommendedRewardsAu === void 0 ? void 0 : _recommendedRewardsAu.includes((_bonusReward$fields$E = bonusReward.fields.ExternalId) === null || _bonusReward$fields$E === void 0 ? void 0 : _bonusReward$fields$E.value)) {
        recommended.push(bonusReward);
      } else if (availableRewards === null || availableRewards === void 0 ? void 0 : availableRewards.includes((_bonusReward$fields$E2 = bonusReward.fields.ExternalId) === null || _bonusReward$fields$E2 === void 0 ? void 0 : _bonusReward$fields$E2.value)) {
        available.push(bonusReward);
      } else {
        unavailable.push(bonusReward);
      }
    });
    setOrderedRewards([].concat(recommended, available, unavailable));
  }, [(_props$rewardsState4 = props.rewardsState) === null || _props$rewardsState4 === void 0 ? void 0 : _props$rewardsState4.rewardsRedemptionResponse]);
  return /*#__PURE__*/React.createElement("div", {
    className: 'rewards-recommendation-listing'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'rewards-recommendation-listing__header'
  }, Header === null || Header === void 0 ? void 0 : Header.value), /*#__PURE__*/React.createElement("span", {
    className: 'rewards-recommendation-listing__copy'
  }, (bonusRewards === null || bonusRewards === void 0 ? void 0 : bonusRewards.length) ? (BonusCopy === null || BonusCopy === void 0 ? void 0 : BonusCopy.value) || '' : (NoBonusCopy === null || NoBonusCopy === void 0 ? void 0 : NoBonusCopy.value) || ''), /*#__PURE__*/React.createElement("div", {
    className: 'rewards-recommendation-listing__container'
  }, orderedRewards === null || orderedRewards === void 0 ? void 0 : orderedRewards.map(function (bonusReward, index) {
    var _bonusReward$fields$E3, _bonusReward$fields$E4;

    return /*#__PURE__*/React.createElement(RewardRedemptionCard, {
      key: "bonus-reward-".concat(index),
      model: bonusReward.fields,
      recommended: recommendedRewards === null || recommendedRewards === void 0 ? void 0 : recommendedRewards.includes((_bonusReward$fields$E3 = bonusReward.fields.ExternalId) === null || _bonusReward$fields$E3 === void 0 ? void 0 : _bonusReward$fields$E3.value),
      available: availableRewards === null || availableRewards === void 0 ? void 0 : availableRewards.includes((_bonusReward$fields$E4 = bonusReward.fields.ExternalId) === null || _bonusReward$fields$E4 === void 0 ? void 0 : _bonusReward$fields$E4.value),
      selectedValues: selectedValues,
      setSelectedValues: setSelectedValues,
      rewardBadge: rewardBadge,
      unavailableRewardCopy: unavailableRewardCopy,
      releaseRedemptionEngineV2: releaseRedemptionEngineV2
    });
  })), (selectedValues === null || selectedValues === void 0 ? void 0 : (_selectedValues$rewar = selectedValues.rewards) === null || _selectedValues$rewar === void 0 ? void 0 : _selectedValues$rewar.length) >= 10 && (selectedValues === null || selectedValues === void 0 ? void 0 : (_selectedValues$rewar2 = selectedValues.rewards) === null || _selectedValues$rewar2 === void 0 ? void 0 : _selectedValues$rewar2.length) !== 12 && /*#__PURE__*/React.createElement("span", {
    className: 'rewards-recommendation-listing__max-rewards'
  }, MaximumRewardsCopy === null || MaximumRewardsCopy === void 0 ? void 0 : MaximumRewardsCopy.value), (selectedValues === null || selectedValues === void 0 ? void 0 : (_selectedValues$rewar3 = selectedValues.rewards) === null || _selectedValues$rewar3 === void 0 ? void 0 : _selectedValues$rewar3.length) === 12 && /*#__PURE__*/React.createElement("span", {
    className: 'rewards-recommendation-listing__limit-rewards'
  }, LimitRewardsCopy === null || LimitRewardsCopy === void 0 ? void 0 : LimitRewardsCopy.value));
};

export default RewardsRecommendationListing;